export interface ISnMapQueryParams {
  pageMapClustered?: boolean;
  pageMapLeftTop: string;
  pageMapRightBottom: string;
  pageMapZoomLevel: number;
  pageMapGridSize?: number;

  [name: string]: any;
}
